import { useState } from 'react'
import * as Sentry from '@sentry/react'
import { IconAlertTriangle } from '@tabler/icons-react'
import Button from './components/ui/Button'
import { isLoggedIn } from './api/auth'
import { useSettings } from './api/settings'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import AcceptInvite from './pages/AcceptInvite'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'

function AppInner() {
  if (window.location.pathname === '/accept-invite') return <AcceptInvite />
  if (window.location.pathname === '/forgot-password') return <ForgotPassword />
  if (window.location.pathname === '/reset-password') return <ResetPassword />

  const settings = useSettings()
  const [authed, setAuthed] = useState(isLoggedIn())

  function handleLogin() {
    setAuthed(true)
    settings.reload() // fetch real settings now that we have a token
  }

  return authed
    ? <Dashboard onLogout={() => setAuthed(false)} />
    : <Login onLogin={handleLogin} />
}

function ErrorFallback({ error, resetError }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f2f5', fontFamily: 'system-ui,sans-serif' }}>
      <div style={{ background: '#fff', borderRadius: 12, border: '0.5px solid #e8e6e0', padding: '40px 36px', maxWidth: 420, textAlign: 'center' }}>
        <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'center' }}>
          <IconAlertTriangle size={32} color="var(--tg-status-danger)" />
        </div>
        <h2 style={{ fontSize: 18, fontWeight: 600, color: '#111', margin: '0 0 8px' }}>Something went wrong</h2>
        <p style={{ fontSize: 13, color: '#888', margin: '0 0 20px', lineHeight: 1.5 }}>
          An unexpected error occurred. It has been reported automatically.
        </p>
        <p style={{ fontSize: 11, color: '#bbb', background: '#f7f7f7', borderRadius: 6, padding: '8px 12px', fontFamily: 'monospace', textAlign: 'left', margin: '0 0 20px', wordBreak: 'break-word' }}>
          {error?.message}
        </p>
        <Button variant="primary" onClick={resetError}>Try again</Button>
      </div>
    </div>
  )
}

export default Sentry.withErrorBoundary(AppInner, { fallback: ErrorFallback })
